import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { StoreHistoryService } from 'src/app/services/store-history/store-history.service';
import { HistorySheetService } from './history-sheet.service';

/**
 * The header control that opens the History sheet.
 *
 * The panel itself is a `mat-sidenav` up in the layout — a full-height right-hand drawer rather
 * than the fixed 329×304 menu the notification bell uses — so all this button does is flip the
 * shared flag. The *trigger* deliberately matches the notification button's size classes and badge,
 * so the header reads as one row of controls.
 */
@Component({
  templateUrl: './history-trigger.component.html',
  standalone: true,
  selector: 'app-history-trigger',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, TranslatePipe],
  styles: `
    #history-btn {
      line-height: 1;

      @media (max-width: 1280px) {
        --mdc-icon-button-state-layer-size: 24px;
        --mdc-icon-button-icon-size: 20px;

        .mat-icon {
          width: 20px;
          height: 20px;
          font-size: 20px;
        }
      }
    }
  `,
})
export class HistoryTriggerComponent {
  private readonly storeHistory = inject(StoreHistoryService);
  private readonly sheet = inject(HistorySheetService);

  /** A dot, not a count: "you have unsaved edits" is the whole message. */
  readonly hasDraft = computed(() => this.storeHistory.draft().length > 0);

  readonly opened = this.sheet.opened;

  onToggle(): void {
    this.sheet.toggle('header');
  }
}
